/** Normalize GET responses that may be a bare array or wrapped payload. */
export function normalizePulseApiPayload(payload) {
  if (Array.isArray(payload)) return payload
  if (payload && typeof payload === "object") {
    const inner =
      payload.data ?? payload.rows ?? payload.content ?? payload.results
    if (Array.isArray(inner)) return inner
  }
  return []
}

/**
 * Pulse API slice rows for the selected property only (no stale / in-flight client data).
 */
export function pulseApiRowsForClient(sliceState, clientKey) {
  if (clientKey == null || clientKey === "") return []
  if (sliceState?.status !== "succeeded") return []
  if (String(sliceState.fetchedClientId ?? "") !== String(clientKey)) return []
  return sliceState.rows ?? []
}

export function beginPulseFetch(state, action) {
  state.status = "loading"
  state.error = null
  state.requestedClientId = String(action.meta.arg.clientId)
  state.fetchedClientId = null
  state.rows = []
}

export function isStalePulseFetch(action, state) {
  return (
    String(action.meta.arg?.clientId ?? "") !==
    String(state.requestedClientId ?? "")
  )
}
